import { BookingNoteType } from '@navio/nsdk';

const BOOKING_NOTE_TITLES: Record<BookingNoteType, string> = {
  [BookingNoteType.ADMIN]: 'Notes from admin',
  [BookingNoteType.CUSTOMER]: 'Notes from customer',
  [BookingNoteType.WORKER]: 'Notes from worker'
};

/**
 * A new note's required title, which the notes UI no longer shows: its audience's, the same title the backend
 * gives notes written through the legacy comment fields.
 */
export const getBookingNoteTitle = (noteType: BookingNoteType) => BOOKING_NOTE_TITLES[noteType];
